export enum PatientIntakeReferralStatus {
    PendingCenter = 1,
    CenterApproved = 2,
    ClosedByCenter = 3,
    CompletedByCenter = 4,
    Transfer = 5,
    CenterDeclined = 6
}

export enum PatientIntakeRegistationStatus {
    PendingScreening = 10,
    SelectCenter = 20,
    CompleteLabTests = 30,
    SentToCenter = 40,
    IfPassCandidate = 98,
    RuledOut = 99
}